import React, { useState, useEffect,useRef } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { addDays } from 'date-fns';
import format from 'date-fns/format'
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
function PointsBreakup(props) {
    const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const { state } = props.location;
    const options = [];
    let textInput = React.createRef();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleNavCollapse = () => {setIsNavCollapsed(!isNavCollapsed)};
    let history = useHistory();
    let newDate = new Date()
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
	useEffect(() => {
		getPointsBreakup();
	}, []);
    const [distData] = useState(state[0]);
    const [opt, setOpt] = useState('');
	const [pointsBreakup, setPointsBreakup] = useState({"status":"failuer","dmt":0,"micro_atm":0,"aeps":0,"recharge":0,"other":0,"month_total":0});
	const [error1, setError] = useState(false);
    const [curMon, setCurMon] = useState('');
    const [open, setOpen] = useState(false);
    const refOne = useRef(null);
    const [miDate, setMiDate] = useState(new Date(1970, 1, 1));
    const [maDate, setMaDate] = useState(new Date());
    const [desc, setDesc] = useState("");
    const inputRef = React.useRef(null)
    const [range, setRange] = useState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection'
        }
    ]);
    useEffect(() => {
        // event listeners
        document.addEventListener("keydown", hideOnEscape, true)
        document.addEventListener("click", hideOnClickOutside, true)
    }, []);
    const hideOnEscape = (e) => {
        // console.log(e.key)
        if( e.key === "Escape" ) {
            setOpen(false);
            if((localStorage.getItem("pbsd") !== localStorage.getItem("pbs") || localStorage.getItem("pbed") !== localStorage.getItem("pbe")) && (localStorage.getItem("pbs") != '' || localStorage.getItem("pbe") != '' ) ){
                console.log('-----=====here=====----');
                newDateRange();
            }
        }
    };
    const hideOnClickOutside = (e) => {
        // console.log(refOne.current)
        // console.log(!refOne.current.contains(e.target));
        if( refOne.current && !refOne.current.contains(e.target) ) {
            setOpen(false);
            if((localStorage.getItem("pbsd") !== localStorage.getItem("pbs") || localStorage.getItem("pbed") !== localStorage.getItem("pbe")) && (localStorage.getItem("pbs") != '' || localStorage.getItem("pbe") != '' ) ){
                console.log('-----=====here=====----');
                newDateRange();
            }
        }
    };
    async function getReport(year, month){
        
        const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({user_id:user_id,month:month,year:year}),
			
		};
        console.log(requestOptions);
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-service-wise-data', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
			console.log(error1);
		}
		setPointsBreakup(data);
        let toShow = monthNames[month-1] + " " + year;
        console.log(toShow);
        setCurMon(toShow);
        setIsNavCollapsed(true);
    }
	const getPointsBreakup = async () => {
        localStorage.setItem("pbsd", "");
        localStorage.setItem("pbed", "");
        var tmp = new Date();
        localStorage.setItem("pbs", format(tmp, "yyyy-MM-dd"));
        localStorage.setItem("pbe", format(tmp, "yyyy-MM-dd"));
		newDateRange();
	};

    async function setRange2(item){
        setRange(item);
        console.log(item);
        localStorage.setItem("pbs", format(item[0].startDate, "yyyy-MM-dd"));
        localStorage.setItem("pbe", format(item[0].endDate, "yyyy-MM-dd"));
    }

    async function newDateRange(){
        console.log("---------------------");
        // console.log(format(range[0].startDate, "yyyy-MM-dd"));
        var sDate = localStorage.getItem("pbs");
        var eDate = localStorage.getItem("pbe");
        const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id },
			body: JSON.stringify({user_id:user_id,start_date:sDate,end_date:eDate}),
			
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-service-wise-data', requestOptions);
		const data = await response.json();
        localStorage.setItem("pbsd", sDate);
        localStorage.setItem("pbed", eDate);
		if (data.status !== "success"){
			setError(true);
            setDesc(data.desc);
            inputRef.current.click();
			console.log(error1);
		} else {
            setPointsBreakup(data);
        }
    }
    return (
<>
    {/* <HelmetProvider> */}
        <Helmet link={
            [{"rel": "stylesheet", "href": 'css/monthly-points.css'}]
        }/>
    {/* </HelmetProvider> */}
        <div className="row no-gutters">
            <div className="bg-gradient application">
                <div className="appHeader bg-transparent text-light position-relative">
                    <div className="left">
                        <a  className="headerButton goBack"  onClick={() => history.goBack()} >
                        <img alt="" src={require("./../images/back.png").default} className="img-fluid" />
                        </a>
                    </div>
                    <div className="pageTitle">Monthly Points</div>
                    <div className="right">
                        <div className="headerButton">
                            <Link to="/faq">
                                <img alt="" src={require("./../images/faq.png").default} className="img-fluid" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="section bg-white actionSheet">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-8 col-12">
                            <div className="card cards-point">
                                <div className="card-body p-0">
                                    <div className="d-inline-block total-points">
                                        <span className="priceLabel">Total Points</span>
                                        <span className="price">{distData.total_points}</span>
                                    </div>
                                    <div className="d-inline-block monthly-points">
                                        <span className="priceLabel">Monthly Points</span>
                                        <span className="price">{pointsBreakup.current_month}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row datepicker-div p-10 col-blue w-100">
                        <div className="dropdown w-70">
                            <div
                                className="inputBox"
                                onClick={ () => setOpen(open => !open) }
                            ><img alt="" src={require("./../images/Calendar-icon.png").default} className="img-fluid" /> {`${format(range[0].startDate, "yyyy-MM-dd")} to ${format(range[0].endDate, "yyyy-MM-dd")}`}</div>

                            <div ref={refOne}>
                                {open && 
                                <DateRange
                                    onChange={item => setRange2([item.selection])}
                                    // onChange={item => setRange([item.selection])}
                                    minDate={miDate}
                                    maxDate={maDate}
                                    editableDateInputs={true}
                                    moveRangeOnFirstSelection={false}
                                    ranges={range}
                                    months={1}
                                    direction="horizontal"
                                    className="calendarElement"
                                />
                                }
                            </div>
                        </div>

                        <div className="right w-30">
                            points - {pointsBreakup.month_total}
                        </div>
                    </div>
                    <div data-toggle="modal" ref={inputRef} data-target="#bottom_modal"  ></div>
                    {/* <div className="row datepicker-div p-10 ">
                        <div >
                            <select id="month-opt"
                            // onChange={() => getReport()}
                            onChange={getReport}
                            className="btn btn-secondary dropdown-toggle scrollable"  >
                                {opt}
                            </select>
                        </div>
                    </div> */}
                    <div>
                        <ul id="bg-grey" className="listview image-listview points-list">
                            <li>
                                <div className="item">
                                    <img src={require("./../images/dhanak.png").default} alt="recharge image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Dhanak</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.dhanak}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/Utility.png").default} alt="recharge image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Utility</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.utility}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/aeps.png").default} alt="aeps image" className="image" />
                                    <div className="in">
                                        <div className="point-name">AEPS</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" /> {pointsBreakup.aeps}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/atm.png").default} alt="atm image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Micro ATM</div>
                                        <span className="text-muted">
                                            <img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" /> {pointsBreakup.micro_atm}
                                            </span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/flights.png").default} alt="recharge image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Flights</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.flights}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/dmt.png").default} alt="image" className="image" />
                                    <div className="in">
                                        <div className="point-name">DMT</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" /> {pointsBreakup.dmt}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/recharge.png").default} alt="recharge image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Mobile/DTH Recharge</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.recharge}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/war_points.png").default} alt="other image" className="image" />
                                    <div className="in">
                                        <div className="point-name">War Points</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.war}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <img src={require("./../images/other.png").default} alt="other image" className="image" />
                                    <div className="in">
                                        <div className="point-name">Other</div>
                                        <span className="text-muted"><img alt="point image" src={require("./../images/Point-logo.png").default} className="img-fluid" />{pointsBreakup.other}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="bg"></div>
            <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                            <h5 className="modal-title">Alert</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                                <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                            </button>
                        </div>
                        <div className="modal-body px-34">
                            <p className="mb-0 text-black">{desc}</p>
                            <div className="row justify-content-center my-3">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</>
    );
}

export default PointsBreakup;
